import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSerialNumberTracking = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSerialNumberTracking);
};
